import React from "react"

export default ({ size = 80 }) => <div className="loader" style={{ height: size, width: size }} />
